import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Nav } from '../../models/nav';
import { NavService } from '../../services/nav/nav.service';

import { ApiService } from '../../services/api/api.service';
import { Data } from '../../models/data';



@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.page.html',
  styleUrls: ['./main-layout.page.scss'],
})
export class MainLayoutPage implements OnInit {

  open(menu)
  {
    menu.openMenu();
  }


  //
  data = new Data();
  user: any;
  wallet: any;
  image: any;
  categories = [];
  //

  navItems: Nav[] = [
    {
      displayName: 'Dashboard',
      iconName: 'home',
      route: 'members/dashboard'
    },
    
    {
      displayName: 'My Account',
      iconName: 'account_circle',
      route: '',
      children: [
        {
          displayName: 'My Profile',
          iconName: 'arrow_right',
          route: 'members/profile',
        },
        {
          displayName: 'Change Password',
          iconName: 'arrow_right',
          route: 'members/password',
        },
        {
          displayName: 'Dealer Commission',
          iconName: 'arrow_right',
          route: 'members/commission',
        },
        {
          displayName: 'Subscribe Account',
          iconName: 'arrow_right',
          route: 'members/subscribe',
        },
        {
          displayName: 'Credit Statement',
          iconName: 'arrow_right',
          route: 'members/credit',
        },
        {
          displayName: 'Check Balance',
          iconName: 'arrow_right',
          route: 'members/balance',
        },
      ]
    },
    {
      displayName: 'Reporting',
      iconName: 'bar_chart',
      route: '',
      children: [
        {
          displayName: 'Sales',
          iconName: 'attach_money',
          route: '',
          children: [
            {
              displayName: 'Sales by Product Type',
              iconName: 'arrow_right',
              route: 'members/sales-product',
            },
            {
              displayName: 'Sales by Provider',
              iconName: 'arrow_right',
              route: 'members/sales-provider',
            },
            {
              displayName: 'Daily Sales',
              iconName: 'arrow_right',
              route: 'members/daily',
            },
            {
              displayName: 'Weekly Sales',
              iconName: 'arrow_right',
              route: 'members/weekly',
            },
            {
              displayName: 'Monthly Sales',
              iconName: 'arrow_right',
              route: 'members/monthly',
            },
            {
              displayName: 'Search Receipt',
              iconName: 'arrow_right',
              route: 'members/receipt',
            }
          ]
        }
      ]
    },
    {
      displayName: 'About',
      iconName: 'info',
      route: '',
      children: [
        {
          displayName: 'FAQ',
          iconName: 'arrow_right',
          route: 'members/faq',
        },
      ]
    },
    
   
  ];

  constructor(private authService: AuthService, private navService: NavService, 
    private apiService: ApiService) {

    console.log(localStorage.getItem('user'));

    //
    this.data =  {
      id: 2,
      name: 'getParamDashboard',
      content: localStorage.getItem('user')
    };
    //
    
   }
   

  ngOnInit() {

     //
     this.apiService.postData(this.data).subscribe((response) => {
      this.wallet = response.data.wallet;
      this.user = response.data.user;
      this.categories = response.data.category;
      console.log(response);
      localStorage.setItem('firstname', this.user.firstname);
      localStorage.setItem('lastname', this.user.lastname);
      localStorage.setItem('companyg', this.user.companyg);
      localStorage.setItem('address', this.user.addr);
      localStorage.setItem('phone', this.user.telephone);
      localStorage.setItem('email', this.user.email);
      localStorage.setItem('wallet', this.wallet);
    });
    //

  }

  logout() {
    this.authService.logout();
  }

  setSubPage() {
    console.log('hello');
  }

  getFirstName() {
    console.log(this.user);
    if (this.user) {
      return this.user.firstname;
    } else {
      return null;
    }
  }

  getLastName() {
    console.log(this.user);
    if (this.user) {
      return this.user.lastname;
    } else {
      return null;
    }
  }

  
  getCompany() {
    console.log(this.user);
    if (this.user) {
      return this.user.companyg;
    } else {
      return null;
    }
  }

}
